export type EventDate = {
  shortDay: string;
  weekday: string;
  day: string;
  time: string;
  year: string;
}

export function isSameDay(start: EventDate, end: EventDate): boolean {
  return start.day === end.day && isSameYear(start, end);
}

export function isSameYear(start: EventDate, end: EventDate): boolean {
  return start.year === end.year;
}

export function getEventDate(dateString: string): EventDate {
  const date = new Date(dateString);
  const weekday = getWeekday(date);
  const shortDay = getShortDay(date);
  const day = getDay(date);
  const time = getTime(date);
  const year = getYear(date);
  return { weekday, day, shortDay, year, time };
}

function getYear(date: Date): string {
  return date.toLocaleDateString('en-US', { year: 'numeric', });
}

function getWeekday(date: Date): string {
  return date.toLocaleDateString('en-US', { weekday: 'long', });
}

function getShortDay(date: Date): string {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function getDay(date: Date): string {
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

function getTime(date: Date): string {
  return date.toLocaleTimeString('en-US', {  hour: "numeric", minute: "numeric"  });
}
